import CustomIcon from "components/CustomIcon";
import Image from "next/image";

export const PassiveVoice = () => {
  return (
    <div className="relative mt-4 flex w-full items-center justify-center rounded-xl bg-[#FEE7E4] p-6 text-center font-montserrat shadow-sm md:mt-3 lg:px-8">
      {/* Badge / Icon Title in the top-left (half-out style) */}
      <div className="absolute -top-6 left-4 flex items-center gap-3 rounded-xl bg-white px-4 py-2 text-base font-semibold shadow-md">
        <Image
          src="/icons/score-check/SentenceMistakes.svg"
          width={28}
          height={28}
          alt="date icon"
          className="h-6 w-6"
        />
        <span className="text-base">Passive Voice</span>
      </div>

      <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-1 px-4 py-6">
        <h3 className="text-lg font-semibold text-[#B94444] lg:text-xl xl:text-2xl">
          Passive Voice Found
        </h3>

        <div className="flex items-center justify-center">
          <Image
            src="/assets/resumeScore/SentenceMistakes.png"
            alt="illustration"
            width={200}
            height={130}
            className="object-contain"
          />
        </div>

        <p className="max-w-3xl text-center text-xs text-gray-700 lg:text-sm">
          Passive voice can make your writing less direct and harder to read. Aim for active voice to create clearer and more engaging sentences.
        </p>
      </div>
    </div>
  );
};
